<fullscreen-page>
  <navigation-column>
    <div class="h-100 d-flex flex-column">
      <div class="px-2 flex-fill overflow-hidden">
        <dx-data-grid
          class="h-100"
          (onToolbarPreparing)="onGridToolbarPreparing($event)"
          [dataSource]="licenseDataSource"
          [remoteOperations]="false"
          [allowColumnReordering]="true"
          [rowAlternationEnabled]="true"
          [allowColumnResizing]="true"
          noDataText=""
          [showBorders]="true"
          (onSelectionChanged)="onLicenseSelected($event)"
        >
          <dxo-selection mode="single"></dxo-selection>
          <div *dxTemplate="let _ of 'newLicenseButtonTemplate'">
            <dx-button
              *ngIf="isAdmin"
              stylingMode="text"
              type="default"
              text="{{ 'Neue Lizenz' | translate }}"
              (onClick)="onAddLicense($event)"
              hint="{{ 'Neue Lizenz anlegen' | translate }}"
            ></dx-button>
          </div>
          <dxo-search-panel
            [visible]="true"
            [highlightCaseSensitive]="true"
            placeholder="{{ 'Lizenz suchen' | translate }} "
          ></dxo-search-panel>
          <dxo-group-panel [visible]="false"></dxo-group-panel>
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
          <dxo-editing mode="row" [useIcons]="true"></dxo-editing>

          <dxo-state-storing
            [enabled]="true"
            type="localStorage"
            storageKey="LicenseManagementLicenses"
            [savingTimeout]=0
          ></dxo-state-storing>

          <dxi-column
            dataField="identifier"
            caption="{{ 'Lizenz' | translate }}"
            cellTemplate="nameCellTemplate"
          ></dxi-column>
          <div *dxTemplate="let data of 'nameCellTemplate'">
            {{ data.data.identifier }}
          </div>

          <dxi-column dataField="active" [width]="100" caption="{{ 'Aktiv' | translate }}"></dxi-column>
          <dxi-column dataField="customerCount" [width]="100" caption="{{ 'Anzahl Kunden' | translate }}"></dxi-column>
          <dxi-column type="buttons" caption="" [width]="50">
            <dxi-button *ngIf="isAdmin" icon="trash" [onClick]="deleteLicense"></dxi-button>
          </dxi-column>

          <dxi-column dataField="id" [visible]="false"></dxi-column>
        </dx-data-grid>
      </div>
    </div>
  </navigation-column>
  <content-column look="light" class="w-100" style="max-width: 67%">
    <div slot="content" class="h-100 w-100 px-3">
      <dx-scroll-view *ngIf="editingLicense" showScrollbar="always" width="100%">
        <div class="dx-fieldset">
          <!--Identifier-->
          <div class="dx-field" npTooltip npTooltipTextId="Der Identifier der Lizenz wird als eindeutiger Bezeichner verwendet">
            <div class="dx-field-label" npTooltipTrigger>
              {{ 'Name' | translate }}
            </div>
            <div
              class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
              npTooltipTarget
            >
              <label class="placeLabel {{ editingLicense.identifier?.length > 0 ? 'placeLabelSmall' : '' }}">LICENSE_IDENTIFIER</label>
              <dx-text-box
                id="identifier"
                [(value)]="editingLicense.identifier"
                [showClearButton]="true"
                (onValueChanged)="updateLicense()"
                [readOnly]="!isManager"
                [valueChangeEvent]="'blur'"
              ></dx-text-box>
            </div>
          </div>

          <!--Active-->
          <div class="dx-field" npTooltip npTooltipTextId="Nur aktive Lizenzen können Kunden zugewiesen werden">
            <div class="dx-field-label" npTooltipTrigger>{{ 'Aktiv' | translate }}</div>
            <div class="dx-field-value">
              <div class="d-flex flex-row pt-2">
                <div class="dx-field-label switch-left">{{ "Nein" | translate }}</div>
                <dx-switch (onValueChanged)="updateLicense()" [(value)]="editingLicense.active"
                           switchedOffText="{{ 'Nein' | translate  }}" switchedOnText="{{ 'Ja' | translate  }}" npTooltipTarget></dx-switch>
                <div class="dx-field-label switch-right">{{ "Ja" | translate }}</div>
              </div>
            </div>
          </div>

          <!--Description-->
          <div class="dx-field" npTooltip npTooltipTextId="Die Beschreibung kann zusätzliche Informationen zur Lizenz enthalten">
            <div class="dx-field-label" npTooltipTrigger>
              {{ 'Beschreibung' | translate }}
            </div>
            <div
              class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
            >
              <label class="placeLabel {{ editingLicense.description?.length > 0 ? 'placeLabelSmall' : '' }}" npTooltipTrigger>
                LICENSE_DESCRIPTION
              </label>
              <dx-text-box
                id="description"
                [(value)]="editingLicense.description"
                [showClearButton]="true"
                (onValueChanged)="updateLicense()"
                [readOnly]="!isManager"
                [valueChangeEvent]="'blur'"
                npTooltipTarget
              ></dx-text-box>
            </div>
          </div>
        </div>
        <dx-tab-panel [items]="licenseTabs">
          <div *dxTemplate="let _ of 'restrictionsTabTemplate'">
            <div class="dx-fieldset">
              <!--MaxProducts-->
              <div class="dx-field" npTooltip npTooltipTextId="Begrenzt die Anzahl der Produkte, die mit dieser Lizenz verwaltet werden können">
                <div class="dx-field-label" npTooltipTrigger>{{ 'Maximale Anzahl Produkte ' | translate }}</div>
                <div class="dx-field-value">
                  <div class="d-flex flex-row pt-2 gap-2 align-items-center" npTooltipTarget>
                    <div class="dx-field-label switch-left">{{ "Unbegrenzt" | translate }}</div>
                    <dx-switch (onValueChanged)="unlimitedProductsChanged($event)" [value]="unlimitedProducts"
                               switchedOffText="{{ 'Begrenzt' | translate  }}" switchedOnText="{{ 'Unbegrenzt' | translate  }}"></dx-switch>
                    <dx-number-box class="flex-fill"
                                   [visible]="!unlimitedProducts"
                                   [(value)]="editingLicense.maxProducts"
                                   (onValueChanged)="updateLicense()"
                                   [showSpinButtons]="true"
                                   [showClearButton]="true"
                                   [min]="0"
                                   [format]="',##0'"
                                   [valueChangeEvent]="'blur'">
                    </dx-number-box>
                  </div>
                </div>
              </div>

              <!--MaxClassifications-->
              <div class="dx-field" npTooltip npTooltipTextId="Begrenzt die Anzahl der Klassifizierungen, die mit dieser Lizenz verwaltet werden können">
                <div class="dx-field-label" npTooltipTrigger>{{ 'Maximale Anzahl Klassifizierungen ' | translate }}</div>
                <div class="dx-field-value">
                  <div class="d-flex flex-row pt-2 gap-2 align-items-center" npTooltipTarget>
                    <div class="dx-field-label switch-left">{{ "Unbegrenzt" | translate }}</div>
                    <dx-switch (onValueChanged)="unlimitedClassificationsChanged($event)" [value]="unlimitedClassifications"
                               switchedOffText="{{ 'Begrenzt' | translate  }}" switchedOnText="{{ 'Unbegrenzt' | translate  }}"></dx-switch>
                    <dx-number-box class="flex-fill"
                                   [visible]="!unlimitedClassifications"
                                   [(value)]="editingLicense.maxClassifications"
                                   (onValueChanged)="updateLicense()"
                                   [showSpinButtons]="true"
                                   [showClearButton]="true"
                                   [min]="0"
                                   [format]="',##0'"
                                   [valueChangeEvent]="'blur'">
                    </dx-number-box>
                  </div>
                </div>
              </div>

              <!--MaxTemplates-->
              <div class="dx-field" npTooltip npTooltipTextId="Begrenzt die Anzahl der Export Templates, die mit dieser Lizenz verwaltet werden können">
                <div class="dx-field-label" npTooltipTrigger>{{ 'Maximale Anzahl Export Templates ' | translate }}</div>
                <div class="dx-field-value">
                  <div class="d-flex flex-row pt-2 gap-2 align-items-center" npTooltipTarget>
                    <div class="dx-field-label switch-left">{{ "Unbegrenzt" | translate }}</div>
                    <dx-switch (onValueChanged)="unlimitedTemplatesChanged($event)" [value]="unlimitedTemplates"
                               switchedOffText="{{ 'Begrenzt' | translate  }}" switchedOnText="{{ 'Unbegrenzt' | translate  }}"></dx-switch>
                    <dx-number-box class="flex-fill"
                                   [visible]="!unlimitedTemplates"
                                   [(value)]="editingLicense.maxTemplates"
                                   (onValueChanged)="updateLicense()"
                                   [showSpinButtons]="true"
                                   [showClearButton]="true"
                                   [min]="0"
                                   [format]="',##0'"
                                   [valueChangeEvent]="'blur'">
                    </dx-number-box>
                  </div>
                </div>
              </div>

              <!--MaxOutputChannels-->
              <div class="dx-field" npTooltip npTooltipTextId="Begrenzt die Anzahl der Ausgabekanäle, die mit dieser Lizenz verwendet werden können">
                <div class="dx-field-label" npTooltipTrigger>{{ 'Maximale Anzahl Ausgabekanäle ' | translate }}</div>
                <div class="dx-field-value">
                  <div class="d-flex flex-row pt-2 gap-2 align-items-center" npTooltipTarget>
                    <div class="dx-field-label switch-left">{{ "Unbegrenzt" | translate }}</div>
                    <dx-switch (onValueChanged)="unlimitedOutputChannelsChanged($event)" [value]="unlimitedOutputChannels"
                               switchedOffText="{{ 'Begrenzt' | translate  }}" switchedOnText="{{ 'Unbegrenzt' | translate  }}"></dx-switch>
                    <dx-number-box class="flex-fill"
                                   [visible]="!unlimitedOutputChannels"
                                   [(value)]="editingLicense.maxOutputChannels"
                                   (onValueChanged)="updateLicense()"
                                   [showSpinButtons]="true"
                                   [showClearButton]="true"
                                   [min]="0"
                                   [format]="',##0'"
                                   [valueChangeEvent]="'blur'">
                    </dx-number-box>
                  </div>
                </div>
              </div>

              <!--MaxUsers-->
              <div class="dx-field" npTooltip npTooltipTextId="Begrenzt die Anzahl der Benutzer, die mit dieser Lizenz verwaltet werden können">
                <div class="dx-field-label" npTooltipTrigger>{{ 'Maximale Anzahl Benutzer ' | translate }}</div>
                <div class="dx-field-value">
                  <div class="d-flex flex-row pt-2 gap-2 align-items-center" npTooltipTarget>
                    <div class="dx-field-label switch-left">{{ "Unbegrenzt" | translate }}</div>
                    <dx-switch (onValueChanged)="unlimitedUsersChanged($event)" [value]="unlimitedUsers"
                               switchedOffText="{{ 'Begrenzt' | translate  }}" switchedOnText="{{ 'Unbegrenzt' | translate  }}"></dx-switch>
                    <dx-number-box class="flex-fill"
                                   [visible]="!unlimitedUsers"
                                   [(value)]="editingLicense.maxUsers"
                                   (onValueChanged)="updateLicense()"
                                   [showSpinButtons]="true"
                                   [showClearButton]="true"
                                   [min]="1"
                                   [format]="',##0'"
                                   [valueChangeEvent]="'blur'" >
                    </dx-number-box>
                  </div>
                </div>
              </div>
                <!--MaxSearchForms-->
                <div class="dx-field" npTooltip npTooltipTextId="Begrenzt die Anzahl der Suchformulare, die mit dieser Lizenz verwaltet werden können">
                    <div class="dx-field-label" npTooltipTrigger>{{ 'Maximale Anzahl Suchformulare ' | translate }}</div>
                    <div class="dx-field-value">
                        <div class="d-flex flex-row pt-2 gap-2 align-items-center" npTooltipTarget>
                            <div class="dx-field-label switch-left">{{ "Unbegrenzt" | translate }}</div>
                            <dx-switch (onValueChanged)="unlimitedSearchFormsChanged($event)" [value]="unlimitedSearchForms"
                                       switchedOffText="{{ 'Begrenzt' | translate  }}" switchedOnText="{{ 'Unbegrenzt' | translate  }}"></dx-switch>
                            <dx-number-box class="flex-fill"
                                           [visible]="!unlimitedSearchForms"
                                           [(value)]="editingLicense.maxSearchForms"
                                           (onValueChanged)="updateLicense()"
                                           [showSpinButtons]="true"
                                           [showClearButton]="true"
                                           [min]="1"
                                           [format]="',##0'"
                                           [valueChangeEvent]="'blur'" >
                            </dx-number-box>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <div *dxTemplate="let _ of 'addonsTabTemplate'">
            <div class="dx-fieldset">
              <!-- Authorized Addons -->
              <div class="dx-field" npTooltip npTooltipTextId="Legt fest, welche Addons mit dieser Lizenz verwendet werden können">
                <div class="dx-field-label" npTooltipTrigger>{{ 'Freigegebene Addons' | translate }}</div>
                <div class="dx-field-value">
                  <dx-tag-box
                    [(value)]="editingLicense.authorizedAddons"
                    [dataSource]="allAddons"
                    [readOnly]="!isAdmin"
                    [acceptCustomValue]="false"
                    [showSelectionControls]="true"
                    [searchEnabled]="true"
                    stylingMode="outlined"
                    (onValueChanged)="updateLicense()"
                    npTooltipTarget
                  ></dx-tag-box>
                </div>
              </div>

              <!-- Customer Default Addons -->
              <div class="dx-field" npTooltip npTooltipTextId="Legt fest, welche Addons bei der Anlage eines neuen Kunden mit dieser Lizenz automatisch aktiviert werden">
                <div class="dx-field-label" npTooltipTrigger>{{ 'Aktivierte Addons bei Kundenanlage' | translate }}</div>
                <div class="dx-field-value">
                  <dx-tag-box
                    [(value)]="editingLicense.customerDefaultAddons"
                    [dataSource]="editingLicense.authorizedAddons"
                    [readOnly]="!isAdmin"
                    [acceptCustomValue]="false"
                    [showSelectionControls]="true"
                    [searchEnabled]="true"
                    stylingMode="outlined"
                    (onValueChanged)="updateLicense()"
                    npTooltipTarget
                  ></dx-tag-box>
                </div>
              </div>
            </div>
          </div>
          <div *dxTemplate="let _ of 'customerTabTemplate'">
            <dx-data-grid
              class="h-100"
              [dataSource]="customerByLicenseDataSource"
              keyExpr="id"
              [remoteOperations]="false"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [allowColumnResizing]="true"
              noDataText=""
              [showBorders]="true"
            >
              <dxo-search-panel
                [visible]="true"
                [highlightCaseSensitive]="true"
                placeholder="{{ 'Account suchen' | translate }} "
              ></dxo-search-panel>
              <dxo-group-panel [visible]="false"></dxo-group-panel>
              <dxo-paging [enabled]="false"></dxo-paging>

              <dxi-column
                dataField="name"
                caption="{{ 'Account' | translate }}"
                sortOrder="asc"
              ></dxi-column>

              <dxi-column dataField="city" caption="{{ 'Stadt' | translate }}"></dxi-column>
              <dxi-column dataField="isTestAccount" [width]="50" caption="{{ 'Test' | translate }}"></dxi-column>
              <dxi-column
                dataField="accountValidDate"
                [width]="95"
                dataType="date"
                [format]="{ type: 'dd.MM.yyyy' }"
                caption="{{ 'Ablauf' | translate }}"
              ></dxi-column>

            </dx-data-grid>
          </div>
        </dx-tab-panel>
      </dx-scroll-view>
    </div>
  </content-column>
</fullscreen-page>

<dx-popup
  [width]="800"
  [height]="'auto'"
  [showTitle]="true"
  title="{{ 'Lizenz löschen' | translate }}"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="deleteLicenseConfirmationDialogVisible"
  contentTemplate="popupContent"
>
  <<dxi-popup-toolbar-item
    toolbar="bottom"
    location="after"
    widget="dxButton"
    [options]="{
      stylingMode: 'outlined',
      text: 'Lizenz löschen' | translate,
      onClick: confirmDeleteLicense
    }"
    [disabled]="!isDeleteConfirmationValid()"
  ></dxi-popup-toolbar-item>
  <div *dxTemplate="let _ of 'popupContent'">
    <dx-scroll-view>
      <div class="dx-fieldset">
        <div class="dx-field d-flex flex-column w-100">
          <div class="dx-field-label w-100 mb-2">
            {{ 'Wiederhole hier die Lizenzbezeichnung um die Lizenz zu löschen' | translate }}
          </div>
          <div class="dx-field-value w-100">
            <dx-text-box [(value)]="deleteLicenseConfirmationText" [valueChangeEvent]="'keyup'" [showClearButton]="true"></dx-text-box>
          </div>
        </div>
      </div>
    </dx-scroll-view>
  </div>
</dx-popup>
